import { useEffect } from 'react';

export function useTelegramAppTheme(): void {
  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (!webApp) {
      return;
    }

    const applyTheme = () => {
      const bgColor = webApp.themeParams.bg_color ?? '#ffffff';
      const textColor = webApp.themeParams.text_color ?? '#121212';
      const secondaryBg = webApp.themeParams.secondary_bg_color ?? '#f4f4f5';
      const accent = webApp.themeParams.button_color ?? '#1f6feb';

      document.documentElement.style.setProperty('--tg-bg', bgColor);
      document.documentElement.style.setProperty('--tg-text', textColor);
      document.documentElement.style.setProperty('--tg-secondary-bg', secondaryBg);
      document.documentElement.style.setProperty('--tg-accent', accent);

      const isDark = webApp.colorScheme === 'dark';
      document.documentElement.className = isDark ? 'theme-dark' : 'theme-light';

      webApp.setBackgroundColor(bgColor);
      webApp.setHeaderColor(bgColor);
    };

    webApp.ready();
    webApp.expand();
    applyTheme();

    webApp.onEvent('themeChanged', applyTheme);
    return () => {
      webApp.offEvent('themeChanged', applyTheme);
    };
  }, []);
}
